
export const act_SaveSettings = (data) => ({ type:'SAVE_SETTINGS', payload:data })

